export default __webpack_public_path__ + "static/media/vida.3afe3748.jpeg";